const bankColors = {
    "Banco Galicia": { primary: "#ED7014" },
    "Tarjeta Naranja": { primary: "#FF8000" },
    "Banco Francés": { primary: "#0033A0" },
    // Agrega más bancos aquí
  };
  
  export default bankColors;
  